// extracted by mini-css-extract-plugin
module.exports =  {"container":"b429494557--container--Wma1H","feature":"b429494557--feature--ZSwCW"};